import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { recordListActions } from '../../config/configuration/react';
import { t } from '../../components/common/Translate';
import { useConcessionsBuyersFilters } from '../useForm/useConcessionsBuyersFilters';
import { nrmTabs } from '../../Store/actions/recordList/recordListActions';

const calculatePageCount = (numberRecords, recordsPerPage) =>
  Math.ceil(Math.max(recordsPerPage, numberRecords) / recordsPerPage);

export const useNrmRecordList = (props) => {
  const urlParams = new URLSearchParams(props?.location?.search);
  const urlTab = urlParams.get('currentTab');
  const dispatch = useDispatch();
  const records = useSelector((state) => state.recordList.records) || [];
  const recordPerPage = useSelector((state) => state.recordList.recordPerPage);
  const currentPage = useSelector((state) => state.recordList.currentPage);
  const counts = useSelector((state) => state.recordList.counts);
  const currentTab = useSelector((state) => state.recordList.currentTab);
  const pageCount = calculatePageCount(counts[currentTab], recordPerPage);
  const loading = useSelector((state) => state.recordList.loading);
  const error = useSelector((state) => state.recordList.error);
  const localStorageFilters = useConcessionsBuyersFilters('onGoingNrm');
  const concessionsLocalS = localStorageFilters?.concessionsLS || [];
  const buyersLocalS = localStorageFilters?.buyersLS || [];
  let sort = useSelector((state) => state.recordList.sort);

  const getReduxFilters = (state, name) => {
    const filters = state.recordList.filtersSupervisor;
    let res = null;
    if (filters[name]) {
      const ids = filters[name].split(',').map(Number);
      switch (name) {
        case 'userId':
          res = buyersLocalS.map((b) => {
            if (ids.includes(b.id)) {
              return {
                value: b.id,
                label: b.fullName,
              };
            }
            return null;
          });
          break;
        default:
          res = concessionsLocalS.map((c) => {
            if (ids.includes(c.id)) {
              return {
                value: c.id,
                label: c.name,
              };
            }
            return null;
          });
          break;
      }

      return res.filter((r) => r != null);
    }
    return [];
  };
  const [buyersSelected, setBuyersSelected] = useState(useSelector((state) => getReduxFilters(state, 'userId')));
  const [concessionSelected, setConcessionSelected] = useState(
    useSelector((state) => getReduxFilters(state, 'concessionId')),
  );
  const [buyersInputValue, setBuyersInputValue] = useState();
  const [concessionInputValue, setConcessionInputValue] = useState();
  const concessionsOptions = concessionsLocalS.map((c) => ({
    value: c.id,
    label: c.name,
  }));
  const buyersOptions = buyersLocalS.map((b) => ({
    value: b.id,
    label: b.fullName,
  }));
  const searchCurrentTab = () => {
    dispatch(recordListActions.fetchNrmRecordForCurrentTab());
  };

  const changeUrlTab = (tab) => {
    urlParams.set('currentTab', tab);
    window.history.pushState({}, '', `${props.location.pathname}?${urlParams.toString()}`);
  };

  const refresh = async () => {
    dispatch(recordListActions.refreshNrmRecordsCount());
    dispatch(recordListActions.getUserFeeds());
    searchCurrentTab();
  };

  const displayTab = (tab) => {
    changeUrlTab(tab);
    dispatch(recordListActions.displayTab(tab));
    searchCurrentTab();
  };

  const goToPage = (page) => {
    dispatch(recordListActions.goTopage(page));
    searchCurrentTab();
  };

  const getFilters = ({ buyerIdFilter, concessionIdFilter }) => ({
    ...(buyerIdFilter !== '' && buyerIdFilter !== null && { userId: buyerIdFilter }),
    ...(concessionIdFilter !== '' && concessionIdFilter !== null && { concessionId: concessionIdFilter }),
  });

  const generateTab = (type) => {
    return {
      type,
      onClick: () => {
        displayTab(type);
      },
      count: counts[type],
      selected: type === currentTab,
      name: t(type),
    };
  };

  const tabs = Object.keys(nrmTabs).map((type) => generateTab(type));

  useEffect(() => {
    if (!urlTab) changeUrlTab(currentTab || 'onGoingNrm');
    else {
      const res = tabs.find((tab) => tab?.type === urlTab);
      if (res) displayTab(urlTab);
      else changeUrlTab(currentTab);
    }
  }, [urlTab]);

  const selectAll = { label: t('select_all'), value: '*' };
  const filters = {
    concessions: {
      value: concessionSelected,
      setValue: (value) => setConcessionSelected(value),
      placeholder: t('point_of_sale'),
      options: concessionsOptions,
      allOption: selectAll,
      inputValue: buyersInputValue,
      setInputValue: (value) => setBuyersInputValue(value),
    },
    buyers: {
      value: buyersSelected,
      setValue: (value) => setBuyersSelected(value),
      placeholder: t('buyer'),
      options: buyersOptions,
      allOption: selectAll,
      inputValue: concessionInputValue,
      setInputValue: (value) => setConcessionInputValue(value),
    },
  };

  useEffect(() => {
    const buyerIdFilter = buyersSelected && buyersSelected.map(({ value }) => value).join(',');
    const concessionIdFilter = concessionSelected && concessionSelected.map(({ value }) => value).join(',');
    const supervisorFilters = getFilters({ buyerIdFilter, concessionIdFilter });
    dispatch(recordListActions.setFilterSupervisor(supervisorFilters));
    refresh();
  }, [buyersSelected, concessionSelected]);

  const setSort = (key) => {
    if (sort?.[0] === key && sort?.[1] === 'DESC') sort = [];
    else if (sort?.[0] === key && sort?.[1] === 'ASC') sort = [key, 'DESC'];
    else sort = [key, 'ASC'];
    dispatch(recordListActions.setSort(sort));
    searchCurrentTab();
  };

  return {
    records,
    goToPage,
    pageCount,
    tabs,
    refresh,
    currentPage,
    loading,
    error,
    filters,
    currentTab,
    setSort,
    sort,
  };
};
